import css1 from '../img/portImages/AmazonPrime.jpg';
import css2 from '../img/portImages/CovidTracker.jpg';
import react1 from '../img/portImages/DisneyPlus.jpg';
import img2 from '../img/portImages/Hulu.jpg';
import img3 from '../img/portImages/Netflix.jpg';
import img4 from '../img/portImages/SpaceX.jpg';
import img5 from '../img/portImages/Tesla.png';

const portfolios = [
    {
        id: 1,
        category: 'CSS, ReactJS',
        image: css1,
        link1: 'https://myprimeclone.netlify.app/',
        title: 'Amazon-Prime Clone',
        text: 'It is an official clone of Amazon-Prime Videos it created using CSS, ReactJS and built by firebase .'
    },
    {
        id: 2,
        category: 'CSS, ReactJS, MERN',
        image: img3,
        link1: 'https://netflix-clone-c9420.web.app/',
        title: 'Netflix-Clone',
        text: 'Official clone of netflix it is created using MERN, CSS, React Native JS and deploy by firebase'
    },
    {
        id: 3,
        category: 'Javascript, CSS, ReactJS',
        image: img4,
        link1: 'https://sanket-ghorpade-94d003.netlify.app/',
        title: 'SpaceX-Clone',
        text: 'Clone of SpaceX website it is an created using Javascript, CSS, ReactJS, and deploy using Netlify'
    },
    {
        id: 4,
        category: 'ReactJS, CSS',
        image: img2,
        link1: 'https://hulu-clone-blue.vercel.app/',
        title: 'Hulu- Clone',
        text: 'It is an Official clone of Hulu app this is created using ReactJS, CSS, Tailwind and deploy by Vercel'
    },
    {
        id: 5,
        category: 'Netlify, CSS, ReactJS, Javascript, python',
        image: img5,
        link1: 'https://tesla-clone-d4fd3.web.app/',
        title: 'Tesla-clone',
        text: 'Clone of Tesla Shopping website it is an created using Javascript, CSS, ReactJS, and deploy using firebase'
    },
    {
        id: 6,
        category: 'React JS, Redux',
        image: react1,
        link1: 'https://disney-clone-d1e27.web.app/',
        title: 'DisneyPlus-clone',
        text: 'Created using different technologies such as Material UI, Styled-Components and more...'
    },
    {
        id: 7,
        category: 'CSS, HTML5, Reactjs',
        image: css2,
        link1: 'https://www.covid19india.org/',
        title: 'Covid Tracker App',
        text: 'Covid tracker app for indicates cases of covid infected in your area or others this made by CSS, HTML5, and ReactJS and deploy using firebase.'
    }
]

export default portfolios;